export default __webpack_public_path__ + "static/media/wf-isf-perspectives-electric-vehicles_1164x584.037ee721.jpg";